import _styled from "styled-components";
import React from "react";
import { m } from "framer-motion";
import { useDeepDiveGallery } from "~/features/blocks/inventory/deep-dive-gallery/context";
import { hasItems } from "~/features/app/utils";
import { DeepDiveGalleryCursor } from "~/features/blocks/inventory/deep-dive-gallery/deep-dive-gallery-cursor";
export type DeepDiveGalleryStepsViewProps<TStep = unknown> = {
  getStepKey?: (step: TStep, index: number) => React.Key;
  renderStep: (step: TStep, index: number, isActive: boolean) => React.ReactNode;
  steps?: TStep[] | null;
};
export function DeepDiveGalleryStepsView<TStep = unknown>(props: DeepDiveGalleryStepsViewProps<TStep>) {
  const {
    getStepKey,
    renderStep,
    steps = []
  } = props;
  const {
    sequenceStarted,
    setSequenceStarted,
    activeStepIndex,
    isVideoPlaying,
    autoPlayStatus,
    setAutoPlayStatus,
    videoPreloadStatus,
    goTo
  } = useDeepDiveGallery();
  const startSequence = React.useCallback(async () => {
    if (sequenceStarted) {
      return;
    }

    // Run in case the gallery has no video.
    if (videoPreloadStatus === "IDLE") {
      setAutoPlayStatus("playing");
    }

    // Run in case the gallery has a video.
    if (videoPreloadStatus === "PRELOADED" && autoPlayStatus === "paused") {
      goTo(0, "playing");
    }
    setSequenceStarted(true);
  }, [autoPlayStatus, goTo, sequenceStarted, setAutoPlayStatus, setSequenceStarted, videoPreloadStatus]);
  const entries = steps ?? [];
  if (!hasItems(entries)) {
    return null;
  }
  return <_StyledMDiv onViewportEnter={() => startSequence()}>
      {entries.map((step, idx) => <React.Fragment key={getStepKey?.(step, idx) ?? idx}>
          {renderStep(step, idx, activeStepIndex === idx && !isVideoPlaying)}
        </React.Fragment>)}

      <DeepDiveGalleryCursor />
    </_StyledMDiv>;
}
var _StyledMDiv = /*#__PURE__*/_styled(m.div).withConfig({
  displayName: "deep-dive-gallery-steps___StyledMDiv",
  componentId: "sc-1wf9hj3-0"
})({
  "position": "absolute",
  "inset": "0"
});